import { dotToCommaTransform } from "@/lib/formatters/NumericTextFieldInputCleaner";
import { Indent } from "@stenajs-webui/core";
import { TextInput } from "@stenajs-webui/forms";
import {
  StandardTableCellRenderer,
  UseGridCellResult,
} from "@stenajs-webui/grid";
import { ModifiedField } from "./ModifiedField";
import {
  EditableEntityState,
  ModifiedFieldItemState,
} from "@stenajs-webui/redux";

export const createEditableCellRenderer =
  <T,>(
    field: keyof T
  ): StandardTableCellRenderer<string, EditableEntityState<T>> =>
  ({ item, gridCell, isEditable }) => {
    return (
      <>
        <EditableTableCell
          gridCell={gridCell}
          onValueChange={(value: string) => {
            gridCell.setEditorValue(value);
          }}
          isEditable={isEditable}
          persistedValue={item.persisted[field] as string | number | null}
          editableValue={item.editable[field] as string | number | null}
          includeOldValue
        />
      </>
    );
  };
interface Props {
  gridCell: UseGridCellResult<string>;
  onValueChange: (value: string) => void;
  isEditable?: boolean;
  persistedValue?: string | number | null;
  editableValue?: string | number | null;
  includeOldValue?: boolean;
  warningOnEmpty?: string;
}

export const EditableTableCell = ({
  gridCell,
  isEditable,
  onValueChange,
  persistedValue,
  editableValue,
  includeOldValue,
  warningOnEmpty,
}: Props) => {
  const modifiedField: ModifiedFieldItemState =
    editableValue === persistedValue
      ? { id: "" }
      : {
          id: "",
          modified: true,
          originalValue: dotToCommaTransform(String(persistedValue)),
          newValue: String(editableValue),
        };

  return isEditable && gridCell.isEditing ? (
    <TextInput
      {...gridCell.requiredProps}
      value={dotToCommaTransform(gridCell.editorValue)}
      onValueChange={onValueChange}
      onDone={() => gridCell.stopEditingAndMove("right")}
      onEsc={gridCell.stopEditingAndRevert}
      autoFocus
      selectAllOnMount={!gridCell.lastKeyEvent}
    />
  ) : (
    <Indent row alignItems={"center"}>
      <ModifiedField
        value={
          persistedValue
            ? dotToCommaTransform(persistedValue.toString())
            : undefined
        }
        modifiedField={modifiedField}
        isEditable={isEditable}
        warningOnEmpty={warningOnEmpty}
        includeOldValue={includeOldValue}
      />
    </Indent>
  );
};
